import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAppSelector } from 'src/store';
import { API_VERSION } from 'src/constants/api-routes';
import { setCreationFlow } from 'src/store/slices/creationFlowSlices';
import { useDispatch } from 'react-redux';

export const CreationFlowWrapper = ({ children }) => {
  const { id } = useParams();
  const location = useLocation();
  const creationFlowState = useAppSelector((s) => s.creationFlowSlices);
  const config = creationFlowState[id];
  const dispatch = useDispatch();
  const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;

  if (config && config.step && !config.finished) {
    let step = +config.step;

    if (step === 3 && version === API_VERSION.V2) {
      step = ++step;

      dispatch(setCreationFlow({ id, step, promptType: 'system' }));
    }

    return (
      <Navigate
        to={`/dashboard/projects/${id}/new/${step}${location.search || ''}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};
